import React from 'react';
import { GeoPointEditor } from '@leverege/ui-geo-elements';
import { useValueChange } from '@leverege/ui-hooks';
import { Flex } from '@leverege/ui-elements';
import GeoPointEqualsComparator from "./GeoPointEqualsComparator.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function GeoPointEqualsComparatorEditor(props) {
  const {
    value,
    variant,
    usage
  } = props;
  const value1 = GeoPointEqualsComparator.getValue1(value);
  const onModelChange = useValueChange(GeoPointEqualsComparator, props);
  const style = usage === 'table' ? {
    width: '100%'
  } : null;
  return /*#__PURE__*/_jsx(Flex, {
    style: style,
    variant: usage === 'table' ? 'colM' : 'rowM',
    align: "stretch",
    children: /*#__PURE__*/_jsx(GeoPointEditor, {
      variant: variant,
      showMenu: false,
      showLabel: false,
      value: value1,
      eventData: "setValue1",
      onChange: onModelChange
    })
  });
}
GeoPointEqualsComparatorEditor.isInline = true;